import { ChangeDetectionStrategy, Component, inject, input, computed } from '@angular/core';
import { UiBreadcrumbComponent } from '@big-direkt/ui/breadcrumb';
import { UiLinkComponent } from '@big-direkt/ui/link';
import { EnvironmentService } from '@big-direkt/utils/environment';
import { IconBigBoldGesperrterContent, IconComponent } from '@big-direkt/utils/icons';
import { translateObjectSignal } from '@jsverse/transloco';
import { type SearchResultItem } from '../../../models/search-result-item';
import { HighlightPipe } from '../../../pipes/highlight.pipe';

@Component({
    selector: 'big-search-result-item',
    templateUrl: './result-item.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        '[class]': 'classList()',
    },
    imports: [HighlightPipe, IconComponent, UiBreadcrumbComponent, UiLinkComponent],
})
export class ResultItemComponent {
    private readonly environmentService = inject(EnvironmentService);
    public readonly myBigIcon = IconBigBoldGesperrterContent;

    public readonly item = input.required<SearchResultItem>();
    public readonly highlightString = input<string>();

    public readonly simplyFillOutOnlineTranslation = translateObjectSignal('search.simplyFillOutOnline');

    public readonly classList = computed(() => {
        const baseClasses = [
            'after:hidden',
            'block',
            'dark:focus-visible:outline-white',
            'dark:hover:bg-primary-400',
            'focus-visible:outline-primary-500',
            'hover:bg-white',
            'no-underline',
            'p-4',
            'relative',
            'rounded-lg',
        ];

        const typeClasses = this.item().type === 'big_form'
            ? ['bg-primary-100', 'dark:bg-primary-500', 'focus-visible:bg-primary-100']
            : [];

        return [...baseClasses, ...typeClasses].join(' ');
    });
    public readonly isPrivateUrl = computed(() => this.item().breadcrumb[0]?.uri.includes(this.environmentService.privatePath));
}
